export default [
  {
    path: '/school',
    name: 'school',
    component: () => import(/* webpackChunkName: "booksGuideApp" */'@/views/school/parent-school.vue'),
  },
  {
    path: '/school/:id',
    name: 'schoolIntroduce',
    component: () => import(/* webpackChunkName: "booksGuideApp" */'@/views/school/parent-school.vue'),
  }
]
